module.exports = __webpack_public_path__ + "img/foodbank.7a9be9ef.png";